import {AddSchema} from "mobx-graphlink";
import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";
import {Phase} from "../../@Shared/Phase.js";

export enum TranscribeTarget {
	panel = "panel",
	dreamSegment = "dreamSegment",
}
AddSchema("TranscribeTarget", {oneOf: GetValues_ForSchema(TranscribeTarget)});

export const VibrationStrength_values = ["light", "medium", "heavy", "doubleClick", "default"] as const;
export type VibrationStrength = typeof VibrationStrength_values[number];
AddSchema("VibrationStrength", {oneOf: VibrationStrength_values.map(a=>({const: a}))});

export class EngineConfig_DreamTranscribe {
	constructor(data: Partial<EngineConfig_DreamTranscribe>) { Object.assign(this, data); }

	enabled: boolean;

	// triggers
	startTranscribeForceEnable_triggerSet: TriggerSet;
	stopTranscribeForceEnable_triggerSet: TriggerSet;

	transcribeBaseEnabledIf_microSnoozeActive: boolean;
	transcribeBaseEnabledIf_inPhases: Phase[];

	transcribeTarget: TranscribeTarget;
	markTimeEveryXMinutes: number;
	timestamps_liteMarkersInBetween: boolean;
	bracketWordsNearTTS: number; // in seconds
	bracketWordsNearTTS_noSpeakCountOrVibrate: boolean;
	bracketWordsNearTTS_noDJ: boolean;
	onTranscribe_speakWordCount: boolean; // if true, will speak the number
	onTranscribe_vibrateDuration: number; // in seconds
	onTranscribe_vibrateStrength: VibrationStrength;

	// solver
	solver_enabled: boolean;
	solver_minWords: number;
	solver_ignoreWordsNearTTS: number; // in seconds
	solver_wordSequence: string;
	solver_minTime: number; // in seconds
	solver_maxTimeValuePerWord: number; // in seconds
	solver_markProgressBeforeCompletion: boolean;
	solver_maxTimeForProgress: number; // in seconds
}
AddSchema("EngineConfig_DreamTranscribe", {
	properties: {
		enabled: {type: "boolean"},
		startTranscribeForceEnable_triggerSet: {$ref: "TriggerSet"},
		stopTranscribeForceEnable_triggerSet: {$ref: "TriggerSet"},

		transcribeBaseEnabledIf_microSnoozeActive: {type: "boolean"},
		transcribeBaseEnabledIf_inPhases: {type: "array", items: {$ref: "Phase"}},

		transcribeTarget: {$ref: "TranscribeTarget"},
		markTimeEveryXMinutes: {type: "number"},
		timestamps_liteMarkersInBetween: {type: "boolean"},
		bracketWordsNearTTS: {type: "number"},
		bracketWordsNearTTS_noSpeakCountOrVibrate: {type: "boolean"},
		bracketWordsNearTTS_noDJ: {type: "boolean"},
		onTranscribe_speakWordCount: {type: "boolean"},
		onTranscribe_vibrateDuration: {type: "number"},
		onTranscribe_vibrateStrength: {$ref: "VibrationStrength"},

		solver_enabled: {type: "boolean"},
		solver_minWords: {type: "number"},
		solver_ignoreWordsNearTTS: {type: "number"},
		solver_wordSequence: {type: "string"},
		solver_minTime: {type: "number"},
		solver_maxTimeValuePerWord: {type: "number"},
		solver_markProgressBeforeCompletion: {type: "boolean"},
		solver_maxTimeForProgress: {type: "number"},
	},
});